var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaccarat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6736_1730)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6736_1730)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8414 1.21811L10.0512 0.0198251C9.29098 -0.115465 8.563 0.393483 8.42771 1.16013L8.36328 1.52734C9.34252 1.64975 10.1736 2.35841 10.4377 3.33121L10.85 4.87738C11.0691 4.78074 11.3203 4.74853 11.5716 4.79363C12.0548 4.87738 12.422 5.22526 12.5573 5.6569C12.8343 5.29613 13.2981 5.09642 13.7813 5.18017C14.4707 5.30257 14.9281 5.9597 14.8057 6.64903C14.5415 8.14366 12.9374 9.34839 12.1772 9.83801L13.3368 14.1737C13.4012 14.4057 13.427 14.6376 13.4205 14.8695L14.3998 15.0434C15.16 15.1787 15.888 14.6698 16.0233 13.9031L17.9753 2.84159C18.1106 2.07494 17.6016 1.34695 16.835 1.21811H16.8414Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41891 3.60226C9.25141 2.97735 8.68448 2.55859 8.06601 2.55859C7.94361 2.55859 7.8212 2.57148 7.6988 2.60369L1.04382 4.39467C0.296507 4.59438 -0.148017 5.36747 0.0516966 6.11479L2.95721 16.9637C3.12471 17.5887 3.69164 18.0074 4.31011 18.0074C4.43251 18.0074 4.55492 17.9945 4.67732 17.9623L11.3323 16.1778C12.0796 15.9781 12.5241 15.205 12.3244 14.4577L9.41891 3.60226ZM4.23924 11.0174C4.12328 10.9208 4.08462 10.7597 4.12972 10.618L5.14762 7.60297C5.23137 7.35172 5.54704 7.26797 5.74676 7.44192L8.13688 9.54213C8.25284 9.63877 8.2915 9.79982 8.2464 9.94156L7.2285 12.9566C7.14475 13.2078 6.82908 13.2916 6.62936 13.1176L4.23924 11.0174Z",
    fill: "#8C8989"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6736_1730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6736_1730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaccarat);
export default __webpack_public_path__ + "static/media/Baccarat.f00eaa41e6cc463aa923bc65e14c4dfa.svg";
export { ForwardRef as ReactComponent };